import BookingDiaryEventComponentHtml from './booking-diary.event.html';

export const BookingDiaryEventComponent : ng.IComponentOptions = {
  bindings: {
    event      : '=',
    jobStatuses: '<'
  },
  controller : 'BookingDiaryEventCtrl',
  templateUrl: BookingDiaryEventComponentHtml
};
